import type { ChatMessageResponseAllOfOnezeroMediaLinksItemProjectInfoEngagementAllOf } from './chatMessageResponseAllOfOnezeroMediaLinksItemProjectInfoEngagementAllOf';
import type { ChatMessageResponseAllOfOnezeroMediaLinksItemProjectInfoEngagementAllOfTwo } from './chatMessageResponseAllOfOnezeroMediaLinksItemProjectInfoEngagementAllOfTwo';

/**
 * 프로젝트 참여 통계
 */
export type ChatMessageResponseAllOfOnezeroMediaLinksItemProjectInfoEngagement = ChatMessageResponseAllOfOnezeroMediaLinksItemProjectInfoEngagementAllOf & ChatMessageResponseAllOfOnezeroMediaLinksItemProjectInfoEngagementAllOfTwo;
